import React from 'react';
import { Scanner } from '@yudiel/react-qr-scanner';

export function QrCodeScanner({ onScan, classNames, styles }) {
    return (
        <Scanner
            classNames={classNames}
            styles={styles}
            onScan={(result) => onScan(result)}
            components={{
                audio: false, // Play beep sound on scan
                torch: true, // Show torch/flashlight button (if supported)
                zoom: true, // Show zoom control (if supported) strangely this disappears if finder is off
                finder: true, // Show finder overlay,
                tracker: highlightCodeOnCanvas
            }}
        />
    );
}

const highlightCodeOnCanvas = (detectedCodes, ctx) => {
    detectedCodes.forEach((detectedCode) => {
        const { boundingBox } = detectedCode;

        // Draw bounding box
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 3;
        ctx.roundRect(
            boundingBox.x,
            boundingBox.y,
            boundingBox.width,
            boundingBox.height,
            5
        );
        ctx.stroke();
    });
};

export const VIBRATE_DURATION = 100;